export default class GlobalErrorMessage extends Component {
  constructor(props) {
    super(props)
    this.state = { error: App.state.error }
  }

  componentDidMount() {
    App.state.on('change', this.onStoreChange)
    this.syncBackdrop()
  }

  componentDidUpdate() {
    this.syncBackdrop()
  }

  componentWillUnmount() {
    App.state.off('change', this.onStoreChange)
    $('.modal-backdrop').removeClass('with-global-error')
  }

  onStoreChange = () => {
    this.setState({ error: App.state.error })
  }

  syncBackdrop = () => {
    if (this.state.error)
      $('.modal-backdrop').addClass('with-global-error')
    else
      $('.modal-backdrop').removeClass('with-global-error')
  }

  okay = () => {
    App.state.setError(null)
  }

  render() {
    let { error } = this.state
    if (!error) return null

    let message = error.message || error.error?.message
    if (!message) return null

    return ReactDOM.createPortal(
      <div className="global-error-message">
        <div className="global-error-message-text alert alert-danger">{message}</div>
        <div className="global-error-message-actions">
          <button className='btn btn-sm btn-primary' onClick={this.okay}>Okay</button>
        </div>
      </div>,
      document.body
    )
  }
}
